import strings from '../localization';

export function shouldShowAdInUserList (index) {
  if (index === 3) {
    return true;
  } else if (index === 8) {
    return true;
  } else if (index > 8 && (index - 8) % 7 === 0) {
    return true;
  }
  return false;
}

export function shouldFetchAds(browseData, storedAds, noOfNewDataFetching = 30) {
  const predictedBrowseLength = browseData.length + noOfNewDataFetching;
  const requiredAdsCount = calculateHowManyAdsWeNeed(predictedBrowseLength);

  return requiredAdsCount > storedAds.length;
}

export function calculateHowManyAdsWeNeed (arrayLength) {
  if (arrayLength < 10) {return 1;}
  if (arrayLength < 18) {return 2;}
  return Math.floor(((parseInt(arrayLength, 10) - 18) / 8) + 3);
}

export function getAdIndexBasedOnListIndex (listIndex) {
  if (listIndex <= 3) {return 0;}
  if (listIndex <= 8) {return 1;}
  return Math.floor(((parseInt(listIndex, 10) - 15) / 7) + 3);
}

export function getRandomAdText () {
  let adText = [
    strings.adsRandomTextMeetNiche,
    strings.adsRandomTextSingleNiche,
    strings.adsRandomTextFindNiche,
    strings.adsRandomTextDateNiche,
    strings.adsRandomTextNicheRomance,
    strings.adsRandomTextLonelyNiche,
    strings.adsRandomTextNicheLove,
    strings.adsRandomTextWhantNiche,
    strings.adsRandomTextNicheDates,
    strings.adsRandomTextMoreNiche,
    strings.adsRandomTextSearchNiche,
    strings.adsRandomTextNicheNow,
    strings.adsRandomTextNichesingles
  ];
  return adText[Math.floor(adText.length * Math.random())];
}

export function openAd (ad) {
  if (ad && ad.redirect && typeof ad.redirect === 'string' && ad.redirect.length > 0 && window && typeof window === 'object') {
    let win = window && window.open(ad.redirect, '_blank');
    win && win.focus();
  }
}
